import { ROLE_ADD, ROLE_DELETE, NOTIFICATIONS_INCLUDE } from '@store/types'
import axios from 'axios'

const actions = {
  [ROLE_ADD]: async ({ dispatch }, { id, ...payload }) => {
    const response = await axios.post(`company/${id}/role`, payload)
    if (response.data.success) {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'A permissão foi adicionada com sucesso'
      })
    } else { dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível adicionar a permissão.')) }
    return response
  },

  [ROLE_DELETE]: async ({ dispatch }, { id, ...payload }) => {
    const response = await axios.delete(`company/${id}/role`, payload)
    if (response.data.success) {
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'A permissão foi removida com sucesso'
      })
    } else { dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível remover a permissão.')) }
    return response
  }
}

export default { actions }



// WEBPACK FOOTER //
// ./src/store/modules/roles.js